import { useCallback } from 'react';
import type { JSX } from 'react';

import { LazyComponent, ScrollableComponent } from 'src/app/shared/components/layout/lazy';

export function LazyTrendingSection(): JSX.Element {
	const loadComponent = useCallback(
		async () =>
			(await import(/* webpackChunkName: "cmp/homepage_trending_section" */ '../TrendingSection')).TrendingSection,
		[],
	);

	return (
		<ScrollableComponent topOffset={200} immediateForBots>
			<LazyComponent loadComponent={loadComponent} />
		</ScrollableComponent>
	);
}
